import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getActiveJob,
    getActiveJobAsync,
    setActiveJob,
    verifyOtp,
    sendOtp,
    cancelJob,
    getBids,
    acceptBid,
    rejectBid,
    changeStatus,
    changeStatusAsync,
    updatePayment,
    acceptCost,
    getMessages,
    addMessage,
    getMessagesAsync,
    getChatMessagesAsync,
    setMessages,
    setChatMessages,
    getWinningBid,
    addChatMessage,
    validateToken,
    setToken,
    setProfile,
    createAccount,
    sendOtpAsync,
    getBidsAsync,
    setBids,
    setBid,
    acceptBidAsync,
    preparePhone,
    defaultImage,
    parseJobStatus,
    getTypeTextGlobal
} from '../../redux/Actions';

import { Redirect } from 'react-router-dom';
import { Tab, Nav, Row, Col, Form, Button, Modal, Card, ListGroup, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCreditCard,
    faMoneyBill,
    faCheck,
    faUser,
    faBox,
    faTruck,
    faComment,
    faPhone,
    faCheckCircle,
    faCheckDouble,
    faBan
} from '@fortawesome/free-solid-svg-icons'
import OTPInput from 'otp-input-react';
import Loader from 'react-loader-spinner';
import PhoneInput from 'react-phone-input-2';
import { store } from 'react-notifications-component';
import ReactStars from 'react-stars';
import StripeCheckout from 'react-stripe-checkout';
import { Launcher } from 'react-chat-window'
import { socket } from '../../socket/socketio';
import { trackEvent } from '../../utils/analytics';
import './Status.css';

class Status extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order'],
            phonenumber: "",
            cancel_reason: "",
            token: null,
            job: null,

            payment_method: "credit_card",
            payment_data: null,

            showModal: false,
            showCancelModal: false,
            priceQuoteModal: false,
            showCash: false,

            loader: true,
            redirect: false,
            redirect_thankyou: false,
            otp_status: false,
            price_quote_list: <center>... waiting for bids ...</center>,

            intervalId: null,
            messages_intervalId: null,

            current_bid: null,
            current_bid_modal_title: '',
            current_bid_modal_text: '',

            status_step1: 'step active',
            status_step2: 'step',
            status_step3: 'step',
            status_step4: 'step',

            job_action_content: '',
            job_cancel_content: '',
            job_cancel_content_flag: false,
            job_prev_status: false,

            chatIsOpen: false,
            messageList: [],
            chatList: [],
            MessagesCount: 0,
            initMessagesCount: -1
        };
    }

    componentWillMount() {
        document.body.classList.add(...this.state.body_class);
    }

    componentDidMount() {
        this.getActiveJob();
        this.socketEvents();
        setTimeout(function () {
            this.checkToken();
            if (this.props.token === null || this.props.token === "" || typeof this.props.token === "undefined") {
                this.otpDialog();
            } else if (this.props.active_job === null || typeof this.props.active_job === "undefined") {
                this.setState({
                    redirect: true
                });
            }
            if (this.props.active_job !== null && this.props.winning_bid && Object.keys(this.props.winning_bid).length !== 0) {
                this.getAsyncChatMessages(true);
            } else {
                this.getAsyncMessages();
            }
            this.setState({
                loader: false,
            });
        }.bind(this), 3000);

        let interval = setInterval(function () {
            this.fetchJobStatus();
        }.bind(this), 30000);

        let interval2 = setInterval(function () {
            if (this.props.active_job !== null && this.props.winning_bid && Object.keys(this.props.winning_bid).length === 0) {
                this.getAsyncMessages();
            }
            if (this.props.active_job !== null && this.props.winning_bid && Object.keys(this.props.winning_bid).length !== 0) {
                this.getAsyncChatMessages(true);
            }
        }.bind(this), 40000);

        this.setState({
            intervalId: interval,
            messages_intervalId: interval2
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
        clearInterval(this.state.messages_intervalId);
    }

    componentDidUpdate(prevProps) {
        if (this.state.token === null && this.state.token !== this.props.token) {
            this.setState({
                token: this.props.token
            });
        }
        if (this.props.global_messages !== undefined && prevProps.global_messages !== this.props.global_messages) {
            this.setState({
                messageList: this._parseMessageList(this.props.global_messages),
                // MessagesCount: this.state.initMessagesCount,
            });
        }
        if (this.props.winning_bid && this.props.winning_bid && this.props.job_messages !== undefined && prevProps.job_messages !== this.props.job_messages) {
            this.setState({
                chatList: this._parseMessageList(this.props.job_messages)
            });
        }
        if (this.state.job === null && this.props.active_job !== undefined && this.state.job !== this.props.active_job) {
            this.setState({
                job: parseJobStatus(this.props.active_job)
            });
        }
    }

    socketEvents() {
        let local = JSON.parse(localStorage.getItem('persist:root'));
        if (local && local.profile) {
            let profile = JSON.parse(local.profile);
            socket.emit('customer', { customerid: profile.customerid, phonenumber: profile.phonenumber });
        }
        socket.on('notification', data => {
            switch (data.action) {
                case 'newbid':
                    this.getActiveJob();
                    this.getJobBids();
                    break;
                case 'chatmessages':
                    this.setState({
                        MessagesCount: this.state.MessagesCount + 1
                    });
                    this.getAsyncChatMessages(false);
                    break;
                case 'messages':
                    this.getAsyncMessages();
                    break;
                case 'statusupdate':
                case 'additionalcost':
                    this.getActiveJob();
                    break;
            }
        });
    }

    _onChatWasSent(message) {
        if (this.props.active_job !== null) {
            this.props.addChatMessage(this.props.active_job.id, message.type, message.data);
        }
        this.getAsyncChatMessages(true);
    }

    _onChatFilesSelected(files) {
        let reader = [];
        let counter = 0;
        Array.from(files).forEach(file => {
            reader[counter] = new FileReader();
            reader[counter].onloadend = (_reader) => {
                if (this.props.active_job !== null && 1) {
                    this.props.addChatMessage(this.props.active_job.id, 'file', { content: _reader.target.result, name: "" });
                }
            }
            reader[counter].readAsDataURL(file);
            counter++;
        });
    }

    _parseMessageList(messages) {
        let parsed_messages = [];
        if (messages !== undefined) {
            messages.map(function (message) {
                let _message = {};
                if (message.author === "customer") {
                    _message = {
                        author: 'me',
                        type: message.type,
                        data: JSON.parse(message.data)
                    }
                } else {
                    _message = {
                        author: 'them',
                        type: message.type,
                        data: JSON.parse(message.data)
                    }
                }
                parsed_messages.push(_message);
            });
        }
        return parsed_messages;
    }

    _onMessageWasSent(message) {
        if (this.props.active_job !== null) {
            this.props.addMessage(this.props.active_job.id, message.type, message.data);
        }
        this.getAsyncMessages();
    }

    _onFilesSelected(files) {
        let reader = [];
        let counter = 0;
        Array.from(files).forEach(file => {
            reader[counter] = new FileReader();
            reader[counter].onloadend = (_reader) => {
                if (this.props.active_job !== null && 1) {
                    this.props.addMessage(this.props.active_job.id, 'file', { content: _reader.target.result, name: "" });
                }
            }
            reader[counter].readAsDataURL(file);
            counter++;
        });
    }

    fetchJobStatus() {
        if (this.props.active_job !== null && typeof this.props.active_job !== "undefined") {
            if (this.props.active_job.id) {
                this.props.getBids(this.props.active_job.id);
                this.checkBids();
                this.getJobAction();
                this.props.getWinningBid(this.props.active_job.id);
                this.updateJobStatus();
                this.props.getActiveJob();
            }
        }
    }

    updateJobStatus() {
        if (this.props.active_job !== null && typeof this.props.active_job !== "undefined") {
            if (this.props.active_job.id) {
                if (([2, 3, 4, 5, 8, 9, 10, 11].includes(this.props.active_job.status))) {
                    this.setState({
                        status_step1: 'step active'
                    });
                }
                if (([3, 4, 5, 8, 9, 10, 11].includes(this.props.active_job.status))) {
                    this.setState({
                        status_step2: 'step active'
                    });
                }
                if (([5, 8, 9, 10, 11].includes(this.props.active_job.status))) {
                    this.setState({
                        status_step3: 'step active'
                    });
                }
                if (([8, 9, 10, 11].includes(this.props.active_job.status))) {
                    this.setState({
                        status_step4: 'step active'
                    });
                }
            }
        }
    }

    async checkToken() {
        let token = this.props.token;
        if (token && this.props.active_job) {
            let status = await validateToken(token);
            if (status !== "true") {
                this.props.setToken('');
                this.props.setProfile({});
                this.props.setActiveJob(undefined);
                this.setState({
                    loader: true,
                    redirect: true
                });
            }
        }
    }

    async getAsyncMessages() {
        let local = JSON.parse(localStorage.getItem('persist:root'));
        let token = this.props.token;
        if (local && local.token) {
            token = local.token.replace(/"/g, "");
        }
        if (this.props.active_job !== null && this.props.active_job && this.props.active_job.id) {
            let data = await getMessagesAsync(token, this.props.active_job.id);
            if (data) {
                this.props.setMessages(data.messages);
                this.setState({
                    messageList: this._parseMessageList(data.messages)
                });
            }

            if (data && this.state.initMessagesCount === -1) {
                this.setState({
                    initMessagesCount: data.messages.length,
                    MessagesCount: 0
                });
            } else if (data && data.messages && this.state.initMessagesCount !== data.messages.length) {
                this.setState({
                    initMessagesCount: data.messages.length,
                    MessagesCount: (data.messages.length - this.state.initMessagesCount),
                });
            }
        }
    }

    async getAsyncChatMessages(calc_flag) {
        let local = JSON.parse(localStorage.getItem('persist:root'));
        let token = this.props.token;
        if (local && local.token) {
            token = local.token.replace(/"/g, "");
        }
        if (this.props.active_job !== null && this.props.active_job && this.props.active_job.id) {
            let data = await getChatMessagesAsync(token, this.props.active_job.id);
            if (data && data.status) {
                if (data) {
                    this.props.setChatMessages(data.messages);
                    this.setState({
                        chatList: this._parseMessageList(data.messages)
                    });
                }
                if (calc_flag) {
                    if (data && this.state.initMessagesCount === -1) {
                        this.setState({
                            initMessagesCount: data.messages.length,
                            MessagesCount: 0
                        });
                    } else if (data && this.state.initMessagesCount !== data.messages.length) {
                        this.setState({
                            initMessagesCount: data.messages.length,
                            MessagesCount: (data.messages.length - this.state.initMessagesCount),
                        });
                    }
                }
            }
        }
    }

    async getJobBids() {
        let local = JSON.parse(localStorage.getItem('persist:root'));
        let token = this.props.token;
        if (local && local.token) {
            token = local.token.replace(/"/g, "");
        }
        let bids = await getBidsAsync(token, this.props.active_job.id);
        this.props.setBids(bids);
        this.checkBids();
        this.getJobAction();
        this.updateJobStatus();
    }

    async getActiveJob() {
        let local = JSON.parse(localStorage.getItem('persist:root'));
        let token = this.props.token;
        if (local && local.token) {
            token = local.token.replace(/"/g, "");
        }
        let active_job = await getActiveJobAsync(token);
        if (typeof active_job !== "undefined") {
            this.props.setActiveJob(active_job.job);
            this.setState({
                job: parseJobStatus(active_job.job)
            });
            setTimeout(function() {
                this.checkBids();
                this.getJobAction();
                this.updateJobStatus();
            }.bind(this), 1000);
        }
        // setTimeout(function() {
        //     this.setState({
        //         loader: false
        //     });
        // }.bind(this), 2000);
    }

    checkBids() {
        if (this.props.bids) {
            let price_quote_content = [];
            this.props.bids.map(function (tech) {
                price_quote_content.push(<ListGroup.Item key={tech.id} action onClick={() => { this.quoteClicked(tech); }}>
                    <Card className="tech_details">
                        {this.getTechImage(tech)}
                        <Card.Body>
                            <Card.Title>{tech.tech_name}</Card.Title>
                            <Card.Text as="div">
                                <Row>
                                    <Col className="rate-text">I have done {tech.tech_finished_jobs ? tech.tech_finished_jobs : 0} jobs </Col>
                                    <Col><ReactStars count={5} className="tech-stars" size={24} color2={'#ffd700'} value={tech.tech_rate} edit={false} /></Col>
                                </Row>
                                <strong>Price:</strong> {tech.bid_price}$ <br />
                                <strong>ETA:</strong> {tech.eta} <br />                                
                                <span className="tech_note"><strong>Note:</strong> {tech.comment}</span>
                                <span id="display_payment_methods"> {tech.tech_balance > 400 ? <span><FontAwesomeIcon icon={faMoneyBill} /> <FontAwesomeIcon icon={faCreditCard} /></span> : <FontAwesomeIcon icon={faCreditCard} />} </span>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </ListGroup.Item>);
            }.bind(this));
            if (price_quote_content.length) {
                this.setState({
                    price_quote_list: price_quote_content
                });
            } else {
                this.setState({
                    price_quote_list: <center>... waiting for bids ...</center>
                });
            }
        } else {
            this.setState({
                price_quote_list: <center>... waiting for bids ...</center>
            });
        }
    }

    getTechImage(tech) {
        if (tech.tech_photo) {
            return <Card.Img variant="top" src={tech.tech_photo} />;
        }
        return <Card.Img variant="top" src={defaultImage()} />

    }

    cancelJob() {
        if (this.state.cancel_reason) {
            this.setState({
                loader: true
            });
            this.props.cancelJob(this.props.active_job.id, this.state.cancel_reason);
            this.setState({
                loader: true,
                redirect: true
            });
        } else {
            store.addNotification({
                title: 'Cancel reason',
                message: 'You need to provide cancel reason',
                type: 'danger',
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        }
    }

    verifyOtp() {
        if (this.state.otp) {
            this.setState({
                loader: true
            });
            this.props.verifyOtp(preparePhone(this.state.phonenumber), this.state.otp);
        }
    }

    setOtp(otp) {
        this.setState({
            otp: otp
        });
    }

    otpDialog() {
        if (this.state.phonenumber === '') {
            this.setState({
                showModal: true,
                modalButtonText: 'Get One Time Password',
                otp_status: false
            });
        } else if (this.state.otp_status === false && this.state.phonenumber !== '') {
            this.sendOtpCode();
            this.setState({
                showModal: true,
                otp_status: true,
                modalButtonText: 'Get Current Price Request'
            });
        } else {
            this.verifyOtp();
            setTimeout(function () {
                if (this.state.token === null || this.state.token === "") {
                    //alert('We cant find your account');
                    //notification.warning('Account not found', 'We cant find your account', 3000);
                    store.addNotification({
                        title: 'Account not found',
                        message: 'We cant find your account',
                        type: 'danger',
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    this.setState({
                        redirect: true
                    });
                } else if (this.state.job === null || typeof this.state.job === "undefined") {
                    //alert('We cant find active price request, redirect to main page');
                    store.addNotification({
                        title: 'No active price request',
                        message: 'We cant find active price request, redirect to main page',
                        type: 'danger',
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    this.setState({
                        redirect: true
                    });
                }
            }.bind(this), 3000);
        }
    }

    async sendOtpCode() {
        //this.props.sendOtp(this.state.phonenumber.replace(/\s/g, ''));
        let resp = await sendOtpAsync(preparePhone(this.state.phonenumber));
        if (resp.error_code) {
            switch (resp.error_code) {
                case "28ca4":
                    store.addNotification({
                        title: 'No active price request',
                        message: 'We cant find active price request, redirect to main page',
                        type: 'danger',
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    this.setState({
                        redirect: true
                    });
                    break;
                default:
                    store.addNotification({
                        title: 'General error occured ' + resp.error_code,
                        message: resp.msg,
                        type: 'danger',
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    break;
            }
        } else {
            this.setState({
                otp_status: true,
            });
        }
    }

    getTypeText() {
        let text = 'House Lockout';
        if (this.state.job !== null && typeof this.state.job !== "undefined") {
            text = getTypeTextGlobal(this.state.job.job_type);
        }
        return text;
    }

    getCardImage() {
        let default_image = defaultImage();
        if (this.props.active_job && this.props.active_job.photos) {
            let photos = JSON.parse(this.props.active_job.photos);
            let photo = default_image;
            if (typeof photos === "object") {
                photo = photos[0];
            }
            return <Card.Img variant="top" src={photo} />;
        }
        return <Card.Img variant="top" src={default_image} />
    }

    getJobTrack() {
        let output = <div className="track">
            <div className={this.state.status_step1}> <span className="icon"> <FontAwesomeIcon icon={faBox} /> </span> <span className="text">Reviewing request</span> </div>
            <div className={this.state.status_step2}> <span className="icon"> <FontAwesomeIcon icon={faUser} /> </span> <span className="text"> Choose quote</span> </div>
            <div className={this.state.status_step3}> <span className="icon"> <FontAwesomeIcon icon={faTruck} /> </span> <span className="text"> Tech is on the way </span> </div>
            <div className={this.state.status_step4}> <span className="icon"> <FontAwesomeIcon icon={faCheck} /> </span> <span className="text">Tech on site</span> </div>
        </div>;
        return output;
    }

    hideModal() {
        this.setState({
            redirect: true
        });
    }

    showCancelModal() {
        this.setState({
            showCancelModal: true
        });
    }

    hideCancelModal() {
        this.setState({
            showCancelModal: false
        });
    }

    hidePriceQuoteModal() {
        this.setState({
            priceQuoteModal: false
        });
    }

    quoteClicked(bid) {
        this.setState({
            current_bid: bid,
            current_bid_modal_title: 'Price quote from: ' + bid.tech_name,
            // current_bid_modal_text: <div>Technician note:<br />{bid.comment}<br /><br /></div>,
            priceQuoteModal: true,
            showCash: bid.tech_balance > 400 ? true : false
        });
    }

    acceptBid() {
        if (this.state.payment_method === "credit_card") {
            this.inputElement.showStripeDialog();
        } else {
            this.acceptBidAction();
        }
    }

    async acceptBidAction() {
        this.props.updatePayment(this.state.payment_method, this.state.payment_data);
        let local = JSON.parse(localStorage.getItem('persist:root'));
        let token = this.props.token;
        if (local && local.token) {
            token = local.token.replace(/"/g, "");
        }
        this.setState({
            priceQuoteModal: false,
            job_prev_status: this.props.active_job.status,
            loader: true
        });
        let data = await acceptBidAsync(token, this.props.active_job.id, this.state.current_bid.id);
        if (data.bids) {
            this.props.setBid(data.bids);
            trackEvent('booking_complete', {
                job_type: this.props.active_job ? this.props.active_job.job_type : 'unknown',
                bid_price: this.state.current_bid ? this.state.current_bid.bid_price : undefined,
            });
        }
        //this.props.acceptBid(this.props.active_job.id, this.state.current_bid.id);
        this.getActiveJob();
        setTimeout(function () {
            this.setState({
                loader: false
            });
        }.bind(this), 1500);
    }

    rejectBid() {
        this.props.rejectBid(this.props.active_job.id, this.state.current_bid.id);
        this.setState({
            priceQuoteModal: false,
            job_prev_status: this.props.active_job.status,
            loader: true
        });
        //this.props.getBids(this.props.active_job.id);
        this.getJobBids();
        setTimeout(function () {
            // this.checkBids();
            this.setState({
                loader: false
            });
        }.bind(this), 1000);
        this.getActiveJob();
        //this.getJobAction();
    }

    async confirmArrival() {
        let local = JSON.parse(localStorage.getItem('persist:root'));
        let token = this.props.token;
        if (local && local.token) {
            token = local.token.replace(/"/g, "");
        }
        this.setState({
            loader: true
        });
        let data = await changeStatusAsync(token, this.props.active_job.id, 9);
        if (data && data.job) {
            this.props.setActiveJob(data.job);
            this.getJobAction();
        }
        setTimeout(function () {
            this.setState({
                loader: false
            });
        }.bind(this), 2000);
        //this.changeStatus(this.props.active_job.id, 9);
    }

    jobDone() {
        this.changeStatus(this.props.active_job.id, 11);
        this.setState({
            redirect_thankyou: true
        });
    }

    changeStatus(jobid, status) {
        this.props.changeStatus(jobid, status);
    }

    openChat() {
        this.setState({
            chatIsOpen: !this.state.chatIsOpen,
            MessagesCount: 0
        });
        //alert('please use app instead');
    }

    callToTech() {
        trackEvent('click_to_call', { source: 'status_page' });
        window.open(`tel:+14159936424%23${this.props.active_job.id}`);
    };

    acceptCost() {
        this.setState({
            loader: true
        });
        this.props.acceptCost(this.props.active_job.id);
        setTimeout(function () {
            this.getActiveJob();
            this.setState({
                loader: false
            });
        }.bind(this), 5000);
    }

    getJobAction() {
        let content = <div style={{ textAlign: "center" }}><Spinner animation="border" variant="warning" /></div>;
        let cancel_content = <div className="text-center status_cancel_button">
            <Button variant="danger" onClick={() => this.showCancelModal()} style={{ width: "100%" }}>
                <FontAwesomeIcon icon={faBan} /> Cancel Job Request
                    </Button>
        </div>;
        let cancel_content_flag = false;
        if (typeof this.props.active_job !== "undefined" && this.props.active_job) {
            if (([2, 3].includes(this.props.active_job.status))) {
                content = <div>
                    <h2 className="text-center price_quotes_title">Choose Price Quotes</h2>
                    <ListGroup>
                        {this.state.price_quote_list}
                    </ListGroup>
                </div>;
                cancel_content_flag = true;
                // cancel_content = <div className="text-center status_cancel_button">
                //     <Button variant="danger" onClick={() => this.showCancelModal()} style={{ width: "100%" }}>
                //         <FontAwesomeIcon icon={faBan} /> Cancel Job Request
                //     </Button>
                // </div>;
            }
            if (([4, 5].includes(this.props.active_job.status))) {
                content = <div>
                    <Row className="justify-content-center">
                        <Col xs={12} md={12} style={{ textAlign: "center" }}><p style={{ paddingTop: "10px" }}>Please confirm that the technician has arrived<br /> to the location by clicking on the confirmation button</p></Col>
                    </Row>
                    <hr /><br />
                    <Row className="justify-content-center">
                        <Col xs={6} md={6}>
                            <Button variant="outline-success" onClick={() => this.openChat()} style={{ width: "100%" }}>
                                <FontAwesomeIcon className={this.state.MessagesCount ? 'blink' : ''} icon={faComment} /> Chat with Tech ({this.state.MessagesCount})
                                    </Button>
                        </Col>
                        <Col xs={6} md={6}>
                            <Button variant="outline-warning" onClick={() => this.callToTech()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faPhone} /> Call Tech
                                    </Button>
                        </Col>
                    </Row>
                </div>;
            }
            if (([8].includes(this.props.active_job.status))) {
                content = <div>
                    <br /><br />
                    <Row className="justify-content-center">
                        <Col xs={6} md={12}>
                            <Button variant="outline-success" onClick={() => this.confirmArrival()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faCheckCircle} /> Confirm Tech Arrival
                                    </Button>
                        </Col>
                    </Row>
                    <br /><hr /><br />
                    <Row className="justify-content-center">
                        <Col xs={6} md={6}>
                            <Button variant="outline-info" onClick={() => this.openChat()} style={{ width: "100%" }}>
                                <FontAwesomeIcon className={this.state.MessagesCount ? 'blink' : ''} icon={faComment} /> Chat with Tech ({this.state.MessagesCount})
                                    </Button>
                        </Col>
                        <Col xs={6} md={6}>
                            <Button variant="outline-warning" onClick={() => this.callToTech()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faPhone} /> Call Tech
                                    </Button>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xs={12} md={12} style={{ textAlign: "center" }}><p style={{ paddingTop: "10px" }}>Please confirm that the technician has arrived<br /> to the location by clicking on the confirmation button</p></Col>
                    </Row>
                </div>;
            }
            if (([9].includes(this.props.active_job.status))) {
                content = <div>
                    <Row className="justify-content-center">
                        <Col xs={12} md={12} style={{ textAlign: "center" }}><p style={{ paddingTop: "10px" }}>The technician arrival is confirmed.<br />Waiting for job completion update from technician.</p></Col>
                    </Row><hr /><br />
                    <Row className="justify-content-center">
                        <Col xs={6} md={6}>
                            <Button variant="outline-success" onClick={() => this.openChat()} style={{ width: "100%" }}>
                                <FontAwesomeIcon className={this.state.MessagesCount ? 'blink' : ''} icon={faComment} /> Chat with Tech ({this.state.MessagesCount})
                                    </Button>
                        </Col>
                        <Col xs={6} md={6}>
                            <Button variant="outline-warning" onClick={() => this.callToTech()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faPhone} /> Call Tech
                                    </Button>
                        </Col>
                    </Row>
                </div>;
            }
            if (([10].includes(this.props.active_job.status))) {
                content = <div>
                    <br /><br />
                    <Row className="justify-content-center">
                        <Col xs={6} md={12}>
                            <Button variant="success" onClick={() => this.jobDone()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faCheckDouble} /> Job Done
                                    </Button>
                        </Col>
                    </Row>
                    <br /><hr /><br />
                    <Row className="justify-content-center">
                        <Col xs={6} md={6}>
                            <Button variant="outline-info" onClick={() => this.openChat()} style={{ width: "100%" }}>
                                <FontAwesomeIcon className={this.state.MessagesCount ? 'blink' : ''} icon={faComment} /> Chat with Tech ({this.state.MessagesCount})
                                    </Button>
                        </Col>
                        <Col xs={6} md={6}>
                            <Button variant="outline-warning" onClick={() => this.callToTech()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faPhone} /> Call Tech
                                    </Button>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xs={12} md={12} style={{ textAlign: "center" }}><p style={{ paddingTop: "10px" }}>Please confirm that the technician has arrived<br /> to the location by clicking on the confirmation button</p></Col>
                    </Row>
                </div>;
            }
            if (this.props.active_job.additional_costs && this.props.active_job.additional_approve_flag === 0) {
                content = <div>
                    <h2 className="text-center price_quotes_title">Additional cost</h2>
                    <Card className="additional_cost">
                        <Card.Body>
                            <Card.Text as="div">
                                <strong><center>Please note techinician sent additinal cost request</center></strong><br />
                                <strong>Additinal cost:</strong> {this.props.active_job.additional_costs}$ <br />
                                <strong>Note:</strong> {this.props.active_job.additional_costs_note}
                            </Card.Text>
                        </Card.Body>
                        <Card.Footer>
                            <Button variant="warning" onClick={() => this.acceptCost()} style={{ width: "100%" }}>
                                <FontAwesomeIcon icon={faCheck} /> Accept
                                    </Button>
                        </Card.Footer>
                    </Card>
                </div>;
            }
        }
        this.setState({
            job_action_content: content,
            job_cancel_content: cancel_content,
            job_cancel_content_flag: cancel_content_flag
        });
        if (this.props.active_job && this.state.job_prev_status !== this.props.active_job.status) {
            this.setState({
                loader: false,
                job_prev_status: this.props.active_job.status
            });
        }
    }

    onPaymentToken(token) {
        this.setState({
            payment_data: token
        });
        this.acceptBidAction();
    }

    changePaymentType(type) {
        this.setState({
            payment_method: type
        });
    }

    render() {
        let otpContent = '';
        if (this.state.otp_status) {
            otpContent = <OTPInput className="otpinput" inputStyles={{ marginRight: '10px' }} value={this.state.otp} onChange={otp => this.setOtp(otp)} autoFocus OTPLength={5} otpType="number" disabled={false} />;
        }
        let job_track = this.getJobTrack();

        if (this.state.redirect) {
            return (<Redirect push to='/order' />);
        }

        if (this.state.redirect_thankyou) {
            return (<Redirect push to='/thankyou' />);
        }

        let stripe_checkout = StripeCheckout ? <StripeCheckout
            name={"Payment for " + this.getTypeText()}
            description="We capturing your payment to make sure with closing job"
            token={(token) => { this.onPaymentToken(token) }}
            stripeKey="pk_live_51IUVJ7DCoV9H6rHlxxMkhzWSDYrbmTHv3QCuFjTYj3OGhX1GLMYWUiY9L9KTU9lt56BlzmkdJ8O2Z1dXo9wCwzoM00dQpPrVck"
            ref={input => this.inputElement = input}
            allowRememberMe={false}
            className="payment_button"
        /> : null;

        let job_card = typeof this.props.active_job !== "undefined" && this.props.active_job ? <div>
            <h2 className="text-center price_quotes_title">Job Details</h2>
            <Card className="payment_job_details_long">
                {this.getCardImage()}
                <Card.Body>
                    <Card.Title>{this.getTypeText()}</Card.Title>
                    <Card.Text>
                        <span><strong>Job description: </strong><br />{this.props.active_job.description ? this.props.active_job.description.split('\n').map((item, i) => <span key={i}>{item}<br /></span>) : ''}<br /></span><br />
                        Address: {this.props.active_job.address} <br />
                        Name: {this.props.active_job.name}
                    </Card.Text>
                </Card.Body>
            </Card>
            <br />
            {this.state.job_cancel_content}
            {this.state.job_cancel_content_flag ?
                <Launcher
                    agentProfile={{
                        teamName: 'GotLocked QnA Chat',
                        imageUrl: '/img/logo64_1.png'
                    }}
                    newMessagesCount={this.state.MessagesCount}
                    onMessageWasSent={this._onMessageWasSent.bind(this)}
                    onFilesSelected={this._onFilesSelected.bind(this)}
                    messageList={this.state.messageList}
                    isOpen={this.state.chatIsOpen}
                    handleClick={() => { this.setState({ MessagesCount: 0, chatIsOpen: !this.state.chatIsOpen }) }}
                    showEmoji={false}
                /> :
                <div className="technician_chat">
                    {this.props.winning_bid && typeof this.props.winning_bid !== "undefined" ?
                        <Launcher
                            agentProfile={{
                                teamName: 'Chat with ' + this.props.winning_bid.tech_name,
                                imageUrl: this.props.winning_bid.tech_photo ? this.props.winning_bid.tech_photo : '/img/logo64_1.png'
                            }}
                            newMessagesCount={this.state.MessagesCount}
                            onMessageWasSent={this._onChatWasSent.bind(this)}
                            onFilesSelected={this._onChatFilesSelected.bind(this)}
                            messageList={this.state.chatList}
                            isOpen={this.state.chatIsOpen}
                            handleClick={() => { this.setState({ MessagesCount: 0, chatIsOpen: !this.state.chatIsOpen }) }}
                            showEmoji={false}
                        />
                        : null
                    }
                </div>}
        </div> : null;

        let payment_modes = this.state.showCash ? 
        <Nav variant="pills" fill="true" rounded="true" mb-3="true" className="fullitem">
            <Nav.Item>
                <Nav.Link eventKey="creditcard" onClick={() => this.changePaymentType('credit_card')}><FontAwesomeIcon icon={faCreditCard} /> Credit Card</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="cash" onClick={() => this.changePaymentType('cash')}><FontAwesomeIcon icon={faMoneyBill} /> Cash</Nav.Link>
            </Nav.Item> 
        </Nav> : 
        <Nav variant="pills" fill="true" rounded="true" mb-3="true">
            <Nav.Item>
                <Nav.Link eventKey="creditcard" onClick={() => this.changePaymentType('credit_card')}><FontAwesomeIcon icon={faCreditCard} /> Credit Card</Nav.Link>
            </Nav.Item>
        </Nav>;

        return (
            <div>
                <Loader
                    type="Watch"
                    color="#fcae4b"
                    height={100}
                    width={100}
                    visible={this.state.loader}
                    className="loader"
                />
                <div className="apps-gotlocked-video-bg-section"></div>
                <section className="apps-gotlocked-order-section" id="apps-gotlocked-order">
                    <div className="apps-gotlocked-order-container">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 payment_page_form">
                                    <div className="apps-gotlocked-order-tbl-c">
                                        <div className="apps-gotlocked-order-content text-center">
                                            <h1>Status Bar</h1>
                                        </div>
                                    </div>
                                    <div className="apps-gotlocked-status">
                                        <div className="row">
                                            <div className="col">
                                                {job_track}
                                                <Row>
                                                    <Col xs={12} md={6} className="apps-gotlocked-status-col">{job_card}</Col>
                                                    <Col xs={12} md={6} className="apps-gotlocked-status-col">{this.state.job_action_content}</Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <Modal show={this.state.showModal} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => this.hideModal()}>
                                        <Modal.Header closeButton>
                                            <Modal.Title id="contained-modal-title-vcenter">
                                                Get active price request
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row className="phone_confirmation">
                                                <Col xs={12} md={6}>
                                                    <PhoneInput prefix='' country={'us'} onlyCountries={['us', 'ca']} inputProps={{ required: true, autoFocus: true }} value={this.state.phonenumber} onChange={phone => {
                                                        this.setState({ phonenumber: phone });
                                                        if (phone.length === 0) {
                                                            this.setState({
                                                                showModal: true,
                                                                modalButtonText: 'Get One Time Password',
                                                                otp_status: false
                                                            });
                                                        }
                                                    }} />
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    {otpContent}
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="success" onClick={() => this.otpDialog()}>{this.state.modalButtonText}</Button>
                                        </Modal.Footer>
                                    </Modal>

                                    <Modal show={this.state.showCancelModal} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => this.hideCancelModal()}>
                                        <Modal.Header closeButton>
                                            <Modal.Title id="contained-modal-title-vcenter">
                                                Cancellation Policy
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <p>All cancellation fees held by GotLocked are only intended to cover our direct cost of amending and/or canceling your reservation. All communications relating to these terms and conditions (in particular any requests to cancel or amend your tour arrangements) must be from the lead traveler of each reservation and processed through the My Adventures portal where travelers can manage their bookings. Once delivered the amendment and/or cancellation needs to be confirmed by Arctic Adventures before further action can be taken. If reimbursement is in order, then it shall be made in accordance with all procedures and processed as quickly as possible, and the stipulated amount will be transferred to the same credit card that was used upon booking. Please note that we can not be responsible for delays of the delivery of the reimbursement to your account once it has been processed on our end. For tours purchased through another vendor please reach out to the vendor directly with your refund and/or cancellation request.</p>
                                            <Form.Label>Cancel reason</Form.Label>
                                            <Form.Control as="textarea" rows="3" onChange={(event) => { this.setState({ cancel_reason: event.target.value }); }} />
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={() => this.cancelJob()}>Cancel Job Request</Button> <Button variant="success" onClick={() => this.hideCancelModal()}>Close</Button>
                                        </Modal.Footer>
                                    </Modal>

                                    <Modal show={this.state.priceQuoteModal} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => this.hidePriceQuoteModal()}>
                                        <Modal.Header closeButton>
                                            <Modal.Title id="contained-modal-title-vcenter">
                                                {this.state.current_bid_modal_title}
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="payment_choose_modal">
                                            {this.state.current_bid_modal_text}
                                            <h3 className="text-center">Please choose payment method</h3>
                                            <Tab.Container defaultActiveKey="creditcard">
                                                <div className="bg-white shadow-sm pt-4 pl-2 pr-2 pb-2">
                                                    {payment_modes}
                                                </div>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="creditcard">
                                                        {stripe_checkout}
                                                        <h6 className="text-center">You will be charged only after you accept a quote and confirm the final order.</h6>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="cash">
                                                        <br />
                                                        <h6 className="text-center">Please note by paying cash, all the responsability is on tech </h6>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Tab.Container>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <center><small>Would you like to accept the price quote from this technician? Please note this decision is final and can’t be disputed</small></center>
                                            <Button variant="success" onClick={() => this.acceptBid()}>Accept</Button> <Button variant="danger" onClick={() => this.rejectBid()}>Reject</Button>
                                        </Modal.Footer>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { active_job, token, bids, winning_bid, global_messages, job_messages, profile } = state;
    return { active_job, token, bids, winning_bid, global_messages, job_messages, profile };
};

export default connect(mapStateToProps, {
    getActiveJob,
    setActiveJob,
    verifyOtp,
    sendOtp,
    cancelJob,
    getBids,
    acceptBid,
    rejectBid,
    changeStatus,
    updatePayment,
    acceptCost,
    getMessages,
    addMessage,
    getMessagesAsync,
    getChatMessagesAsync,
    setMessages,
    setChatMessages,
    getWinningBid,
    addChatMessage,
    validateToken,
    setToken,
    setProfile,
    createAccount,
    sendOtpAsync,
    setBids,
    setBid
})(Status);
//export default Status;